import { MultiTypeEnum, SKU } from 'domains/skuDomain';

export const useSkuSvcRole = (sku: Partial<SKU>) => {
  return {
    isJobOption: Boolean(
      sku?.multiType &&
        [
          MultiTypeEnum.WRAPPER,
          MultiTypeEnum.BOTH,
          MultiTypeEnum.STANDALONE,
        ].includes(sku?.multiType)
    ),
    isRequiredSvc: Boolean(
      sku?.multiType &&
        [
          MultiTypeEnum.PART,
          MultiTypeEnum.BOTH,
          MultiTypeEnum.STANDALONE,
        ].includes(sku?.multiType)
    ),
    isAdditionalJobOption: Boolean(
      sku?.multiType &&
        [
          MultiTypeEnum.WRAPPER,
          MultiTypeEnum.BOTH,
          MultiTypeEnum.STANDALONE,
        ].includes(sku?.multiType)
    ),
    isOptionalSvc: Boolean(
      sku?.multiType &&
        [
          MultiTypeEnum.PART,
          MultiTypeEnum.BOTH,
          MultiTypeEnum.STANDALONE,
        ].includes(sku?.multiType)
    ),
  };
};
